const generateSrcset = (image, widths = []) => {
	const imageUrl = new URL(image["src"]);
	return widths
		.filter((width) => width <= image["width"])
		.map((width) => {
			imageUrl.searchParams.set("width", width.toString());
			return `${imageUrl.href} ${width}w`;
		})
		.join(", ");
};

const createImageElement = (image, classes, sizes, productTitle) => {
	const previewImage = image["preview_image"];
	const newImage = new Image(previewImage["width"], previewImage["height"]);
	newImage.className = classes;
	newImage.alt = image["alt"] || productTitle;
	newImage.sizes = sizes;
	newImage.src = previewImage["src"];
	newImage.srcset = generateSrcset(
		previewImage,
		[165, 360, 533, 720, 940, 1066]
	);
	newImage.loading = "lazy";
	return newImage;
};

const checkSwatches = () => {
	document.querySelectorAll(".js-color-swatches-wrapper").forEach((wrapper) => {
		wrapper.querySelectorAll(".js-color-swatches input").forEach((input) => {
			input.addEventListener("click", (event) => {
				const primaryImage = wrapper.querySelector(".media--first");
				const secondaryImage = wrapper.querySelector(".media--second");
				const handleProduct = wrapper.dataset.product;

				if (event.currentTarget.checked && primaryImage) {
					wrapper
						.querySelector(".js-color-swatches-link")
						.setAttribute("href", event.currentTarget.dataset.variantLink);
					const currentColor = event.currentTarget.value;

					jQuery.getJSON(
						window.Shopify.routes.root + `products/${handleProduct}.js`,
						function (product) {
							const variant = product.variants.filter(
								(item) =>
									item.featured_media != null &&
									item.options.includes(currentColor)
							)[0];
							if (variant) {
								const newPrimaryImage = createImageElement(
									variant["featured_media"],
									primaryImage.className,
									primaryImage.sizes,
									product.title
								);

								if (newPrimaryImage.src !== primaryImage.src) {
									let flag = false;
									if (secondaryImage) {
										const secondaryImagePathname = new URL(secondaryImage.src).pathname;
										const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

										if (secondaryImagePathname == newPrimaryImagePathname) {
											primaryImage.remove();
											secondaryImage.classList.remove("media--second");
											secondaryImage.classList.add("media--first");
											flag = true;
										}
									}
									if (flag == false) {
										primaryImage.animate(
											{ opacity: [1, 0] },
											{ duration: 200, easing: "ease-in", fill: "forwards" }
										).finished;
										setTimeout(function () {
											primaryImage.replaceWith(newPrimaryImage);
											newPrimaryImage.animate(
												{ opacity: [0, 1] },
												{ duration: 200, easing: "ease-in" }
											);
											if (secondaryImage) {
												secondaryImage.remove();
											}
										}, 200);
									}
								}
							}
						}
					);
				}
			});
		});
	});
};

function colorSwatches() {
	checkSwatches();

	document.addEventListener("shopify:section:load", function () {
		checkSwatches();
	});
}

// The card's second image ships as data-src/data-srcset (snippets/product-card.liquid) and is only
// ever loaded on devices that can hover: ahead of time for cards near the viewport, once the page
// has loaded, and on the first hover for anything that slipped past that.
const SECONDARY = ".product-card__media--secondary[data-srcset]";

const loadSecondary = (image) => {
	if (!image.dataset.srcset) return;
	const media = image.closest(".media--hover-effect");
	if (media) image.addEventListener("load", () => media.classList.add("is-secondary-ready"), { once: true });
	image.loading = "eager";
	image.srcset = image.dataset.srcset;
	if (image.dataset.src) image.src = image.dataset.src;
	image.removeAttribute("data-srcset");
	image.removeAttribute("data-src");
};

if (window.matchMedia("(hover: hover) and (pointer: fine)").matches && "IntersectionObserver" in window) {
	const preload = () => {
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (!entry.isIntersecting) return;
					observer.unobserve(entry.target);
					loadSecondary(entry.target);
				});
			},
			{ rootMargin: "300px 0px" }
		);
		const watch = (root) => root.querySelectorAll(SECONDARY).forEach((image) => observer.observe(image));
		watch(document);
		// Infinite scroll and section reloads add cards after this ran.
		new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				mutation.addedNodes.forEach((node) => {
					if (node.nodeType === 1) watch(node);
				});
			});
		}).observe(document.body, { childList: true, subtree: true });
	};
	if (document.readyState === "complete") preload();
	else window.addEventListener("load", preload, { once: true });
}

document.addEventListener("pointerover", (event) => {
	if (event.pointerType !== "mouse" || !event.target.closest) return;
	const card = event.target.closest(".card-wrapper");
	const image = card && card.querySelector(SECONDARY);
	if (image) loadSecondary(image);
});

(function () {
	colorSwatches();
})();
